import { Injectable } from '@angular/core';
// import { async } from '@angular/core/testing';
import { Platform } from '@ionic/angular';
import jsQR from 'jsqr';
import { ModulesManagerService } from '../Module/modules-manager.service';
import { LoggerService } from '../../utils/logger.service';
@Injectable({
  providedIn: 'root'
})
export class ScanQr {
  private tickRate: number = 333 //ms entre chaque calcule d'image
  private canvasElement: any;
  private canvasContext: any;
  private videoElement: any;
  private stream: MediaStream;
  private manager: ModulesManagerService;
  private scanActive = false;
  private callBack: any;
  constructor(private plt: Platform) { }

  set Manager(value: ModulesManagerService) {
    this.manager = value
  }

  get isActive() {
    return this.scanActive
  }

  get isReady() {
    return this.canvasElement != null && this.videoElement != null && this.canvasContext != null
  }

  get isAvaibleForThisPlatforme() {
    return !(this.plt.is('ios') && this.isInStandaloneMode);
  }

  get isInStandaloneMode() {
    return 'standalone' in window.navigator && window.navigator['standalone'];
  }

  private async defineStream() {
    if (this.stream == null) {
      this.stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: "environment",
          frameRate: { ideal: 30, max: 30 }
          /*advanced:[
              {focusMode:"continuous"}
          ]*/
        }
      })
    }
    this.videoElement.srcObject = this.stream;
    // Required for Safari
    this.videoElement.setAttribute('playsinline', true);
  }


  async Scan(canvasElement, videoElement) {
    await this.manager.Tool.DeviceReady()
    if (!await this.manager.hasCameraPermission()) {
      this.manager.Tool.notify(this.manager.Trad.Parse("STR_NO_PERMISSION"));
      return null
    }
    if (this.scanActive) {
      LoggerService.warn("ScanQr: scan already run, you should stop before")
      this.stop()
    }
    return new Promise(async (cb, fail) => {
      try {
        this.callBack = cb
        this.canvasElement = canvasElement
        this.canvasContext = this.canvasElement.getContext('2d');
        this.videoElement = videoElement
        await this.start();
        if (!this.isActive) fail()
      } catch (error) {
        fail(error)
      }
    })
  }

  private answerCB(txt: string = "") {
    this?.callBack(txt)
    this.callBack = null
  }

  private reset() {
    this.answerCB()
  }

  public stop() {
    if (!this.scanActive) return;
    this.stream?.getTracks().forEach(track => track.stop())
    this.videoElement?.pause();
    this.stream = null
    this.reset()
    this.scanActive = false

  }

  private async start() {
    if (!this.isAvaibleForThisPlatforme) return await this.manager?.Tool.notify(this.manager?.Trad.Parse('STR_NOT_SUPPORTED'));
    if (!this.isReady) return LoggerService.error("ScanQr: HTMLElements is not defined");
    let succes = await this.defineStream().then(() => true).catch(() => false)
    if (!succes) return; //await this.manager?.Tool.notify(this.manager?.Trad.Parse('STR_ERROR'))
    this.scanActive = true;
    this.videoElement.play();
    requestAnimationFrame(this.scan.bind(this));
  }

  private async scan() {

    await this.manager?.Tool.sleep(this.tickRate)
    if (!this.isReady) {
      if (this.scanActive)
        requestAnimationFrame(this.scan.bind(this));

      return
    }

    if (this.videoElement?.readyState === this.videoElement?.HAVE_ENOUGH_DATA) {

      this.canvasElement.height = this.videoElement.videoHeight;
      this.canvasElement.width = this.videoElement.videoWidth;

      this.canvasContext.drawImage(this.videoElement, 0, 0, this.canvasElement.width, this.canvasElement.height);
      const imageData = this.canvasContext.getImageData(0, 0, this.canvasElement.width, this.canvasElement.height);
      const code = jsQR(imageData.data, imageData.width, imageData.height, {
        inversionAttempts: 'dontInvert'
      });

      if (code) {
        this.scanActive = false;
        this.answerCB(code.data)
        this.stop()
      } else if (this.scanActive) {
        requestAnimationFrame(this.scan.bind(this));
      }
    } else if (this.scanActive) {
      requestAnimationFrame(this.scan.bind(this));
    }
  }
}
